import React from 'react';
import '../styles/Servizi.css'; 
import { Link } from 'react-router-dom'; // Assicurati di avere react-router-dom installato

// Import loghi esistenti
import discordLogo from '../assets/discord-round-color-icon.png';
// Import loghi nuovi
import hpeLogo from '../assets/synodsm.png'; 
import speedtestLogo from '../assets/speedtest.png';
import jellyfinLogo from '../assets/jellyfin.jpeg';
import j4flogo from '../assets/j4f_logo128x128.png';

const Servizi = () => {
  const serviziList = [
    { 
      name: 'Just4Fun APP', 
      url: '/j4f-app', 
      img: j4flogo, 
      class: 'card-dsbot',
      isInternal: true, // Flag per usare <Link> invece di <a> se necessario
    },
    { name: 'Discord', url: 'https://discord.just4fun.it', img: discordLogo, class: 'card-discord' },
    { name: 'SpeedTest', url: 'https://speedtest.just4fun.it', img: speedtestLogo, class: 'card-speed' },
    { name: 'HPE Server DSM', url: 'https://nas.just4fun.it', img: hpeLogo, class: 'card-hpe' },
    { name: 'JellyFlix', url: 'https://jellyfin.just4fun.it', img: jellyfinLogo, class: 'card-jelly' },
  ];

return (
    <div className="servizi-page">
      <div className="servizi-container">
        <header className="home-header">
          <h1 className="titolo-principale">I nostri Servizi</h1>
          <p className="sottotitolo-testo">Tutto il mondo Just4Fun in un unico posto</p>
        </header>

        <div className="services-grid">
          {serviziList.map((servizio, index) => {
            // Controlliamo se l'URL è un percorso interno (inizia con /)
            const isInternal = servizio.url.startsWith('/');

            const cardContent = (
              <div className="card-content">
                <img src={servizio.img} alt={servizio.name} className="service-img" />
                <span>{servizio.name}</span>
              </div>
            );

            if (isInternal) {
              // Link INTERNO: Usa <Link> senza target="_blank"
              return (
                <Link 
                  key={index} 
                  to={servizio.url} 
                  className={`service-card ${servizio.class}`}
                >
                  {cardContent}
                </Link>
              );
            } else {
              // Link ESTERNO: Usa <a> con target="_blank"
              return (
                <a 
                  key={index} 
                  href={servizio.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className={`service-card ${servizio.class}`}
                >
                  {cardContent}
                </a>
              );
            }
          })}
        </div>

        {/* Box info aggiornato con le tue specifiche */}
        <div className="info-box mt-5">
          <h3>Serve aiuto o accesso?</h3>
          <p>
            L'assistenza tecnica è disponibile H24 sul nostro server Discord!
          </p>
          <hr style={{ borderTop: '1px solid rgba(230, 81, 0, 0.2)', margin: '15px 0' }} />
          <p style={{ fontSize: '0.95rem', fontWeight: '500' }}>
            <strong>Nota bene:</strong> La maggior parte dei servizi elencati richiede credenziali d'accesso. 
            L'utilizzo dei portali è <strong>riservato esclusivamente ai collaboratori</strong> della community. 
            Puoi richiedere l'abilitazione di persona tramite l'assistenza dedicata su Discord.
          </p>
        </div>
        
      </div>
    </div>
  );
};

export default Servizi;